<template>
  <JoszakiModal
    :open="isOpen"
    :title="$t('customerLoginRequiredModal.title')"
    @cancel="isOpen = false"
    @close="isOpen = false"
  >
    <template #body>
      <JoszakiLoading :active="isSending" />
      <p class="text-xl text-left md:text-center">
        {{ $t("customerLoginRequiredModal.existingAccount") }}
      </p>
      <p class="text-xl text-left md:text-center">
        {{ $t("customerLoginRequiredModal.loginFirst") }}
      </p>
      <p>
        {{ $t("customerLoginRequiredModal.noPassword") }}
      </p>
    </template>

    <template #footer>
      <div class="w-full flex justify-between">
        <JoszakiButton type="info" :inverted="true" @click="onSend"
          ><span class="font-bold">{{
            $t("customerLoginRequiredModal.sendPasswordRecovery")
          }}</span></JoszakiButton
        >
        <JoszakiButton type="success" :to="loginRoute">
          {{ $t("customerLoginRequiredModal.login") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import {
  computed,
  ref,
  useContext,
  useRoute,
  useRouter,
} from "@nuxtjs/composition-api";
import { useRegistration } from "./useRegistration";
import { useSendPasswordRecovery } from "~/components/_refactored/auth";

/**
 * Shown when the backend refuses to turn an existing customer account into a
 * professional one (CUSTOMER_LOGIN_REQUIRED): only the logged-in owner may do
 * that. Login brings them back here (returnTo), where the wizard keeps its data.
 */
export default {
  setup() {
    const { $logger, localePath } = useContext();
    const route = useRoute();
    const router = useRouter();
    const { email } = useRegistration();
    const isOpen = ref(false);
    const isSending = ref(false);

    const sendPasswordRecovery = useSendPasswordRecovery();

    const loginRoute = computed(() =>
      localePath({
        name: "login",
        query: { email: email.value, returnTo: route.value.fullPath },
      })
    );

    const open = () => {
      isOpen.value = true;
    };

    async function onSend() {
      try {
        isSending.value = true;
        await sendPasswordRecovery({ email: email.value });
        isOpen.value = false;
        setTimeout(() => {
          router.push(loginRoute.value);
        }, 3000);
      } catch (error) {
        $logger.error(error);
      } finally {
        isSending.value = false;
      }
    }

    return {
      isOpen,
      open,
      onSend,
      isSending,
      loginRoute,
    };
  },
};
</script>
